<template>
<div>
      <div >
          <v-dialog v-model="show"
          max-width="500" content-class="elevation-0"  >
            <template >
                <div >
                  <v-container>
                    <v-row>
                     <v-spacer></v-spacer>
                     <v-col
                      cols="1"
                      md="1"
                      style="margin-right: 10px;"
                      >
                        <v-btn icon dark @click="show=false"> <v-icon>mdi-close</v-icon> </v-btn>
                      </v-col>
                     </v-row>

                    <v-row>
                       <v-card
                        class="mx-auto "
                         max-width="380"
                        >
                          <display-image
                            :imageId="modalItem.id"
                            :maxWidth="380"
                            style="  display: contents;"
                            borderRadius = true
                          ></display-image>
                          <v-list style="height: 250px; overflow-y: scroll">
                          <v-list-item-content class="informationBlock" >
                            <v-list-item-title >
                              <p id="Name">{{modalItem.name}} {{modalItem.surname}}</p>
                            </v-list-item-title>
                            <!-- <v-list-item-subtitle><p>{{modalItem.position}}</p></v-list-item-subtitle> -->
                            <div class="">
                              <p>{{modalItem.position}}</p>
                            </div>
                          </v-list-item-content>

                          <v-list-item-content class="contactBlock">
                            <v-list-item-subtitle>
                              <p><b id="Adress">Email:</b> <b id="Contact"><a :href="'mailto:' + modalItem.email">{{modalItem.email}}</a></b></p>
                            </v-list-item-subtitle>
                            <v-list-item-subtitle>
                              <p><b id="Adress">Skype:</b> <b id="Contact"><a :href="'skype:'+ modalItem.skype">{{modalItem.skype}}</a></b></p>
                            </v-list-item-subtitle>
                              <v-list-item-subtitle>
                                <p><b id="Adress">{{ $t('human.numberOfPhone')}}</b> <b id="Contact">{{modalItem.phone}}</b></p>
                              </v-list-item-subtitle>
                              <v-list-item-subtitle>
                                <p><b id="Adress">{{ $t('human.dateOfBirth')}}</b> <b id="Contact">{{modalItem.date}}</b></p>
                              </v-list-item-subtitle>
                              <v-list-item-subtitle>
                                <p><b id="Adress">{{ $t('human.innerNumber')}}</b> <b id="Contact">{{modalItem.innerNumber}}</b></p>
                              </v-list-item-subtitle>
                              <!-- <v-list-item-subtitle class="descriptionBlock">
                                <div style="text-align: left">
                                  <p>{{modalItem.description}}</p>
                                </div>
                              </v-list-item-subtitle> -->
                              <div class="descriptionBlock">
                                  <p>{{modalItem.description}}</p>
                                </div>
                          </v-list-item-content>
                          </v-list>
                        </v-card>
                      </v-row>
                  </v-container>
                  </div>
             </template>
          </v-dialog>
      </div>
    <div class="containerHuman__container" >
        <div class="containerHuman__itemHuman itemHuman" v-for="(item, index) in items" :key="index">
        <v-row >
            <v-col
             cols="4"
             v-on:click="openModal(item)"
            >
                <display-image
                :maxHeight="120"
                :maxWidth="120"
                :aspect="1"
                height="100%"
                :imageId="item.id"
                circle = true
                id="image"
                ></display-image>
            </v-col>
            <v-col
             cols="7"
            >
                <v-row>
                    <h1  class="nameHuman" @click="openModal(item)" >{{item.name}} {{item.surname}}</h1>
                </v-row>
                <v-row>
                    <p  class="positionHuman"  @click="openModal(item)" >{{ getPosition(item.position)}}</p>
                </v-row>
            </v-col>
        </v-row>
        </div>
    </div>
    </div>
</template>
<script>

import DisplayImage from './DisplayImage'
export default {
  name: 'HumanWiew',
  components: {
    DisplayImage
  },
  props: {
    items: Array
  },
  methods: {
    openModal(item) {
      this.modalItem = item
      this.show = true
    },
    getPosition(position) {
      if (position.length >= 71) {
        return position.substr(0, 71) + '...'
      } else {
        return position
      }
    }
  },
  data: () => ({
    modalItem: {},
    show: false
  })
}
</script>
<style lang="scss" >
.nameHuman {
    margin-top: 22px;
    margin-left: 5px;
    color:#3A3A3A;
    font-size: 20px;

}
#image{
  cursor: pointer;
}
.nameHuman:hover{
  cursor: pointer;
}
.positionHuman:hover {
  cursor: pointer;
}
.positionHuman {
    margin-left: 5px;
    color:#969696;
    font-size: 16px;
    :hover{
      cursor: pointer;
    }
}
.descriptionHuman {
    color:#3A3A3A;
    font-size: 16px;
}
.containerHuman {
  overflow: auto;
  column-gap: normal;

  &__container {
    column-count:2;
    -webkit-column-gap: 2em;
    -moz-column-gap: 2em;
    column-gap: 2em;
  }

  &__item {
    page-break-inside: avoid; // prevent break content: modern
    display: inline-block;    // prevent break content: fallback

    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }
}

.itemHuman {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 3px;
  padding: 20px 0;
  background-color: #FFFFFF;
  margin: 0 24px 20px 24px;
   break-inside: avoid;

}
.imageBlock {
  display: inline-block;
}
.informationBlock {
  #Name {
    margin-bottom: 10px;
    font-size: 20px;
    color:#3A3A3A
  }
  p {
    margin-left: 15px;
    margin-bottom: 5px;
    font-size: 14px;
    color:#969696;
  }

}
.contactBlock {
   margin-left: 15px;

  #Adress {
    color: #969696;
    font-size: 14px;
  }
  #Contact {
    color: #4690BA;
    float: right;
    margin-right: 15px;
    font-size: 14px;

  }
.descriptionBlock {
  font-size: 15px;
  p {
    margin-right: 10px;
  }
}

}
</style>
<style lang="css">
::-webkit-scrollbar {
    width: 8px;
    height: 6px;
  }
::-webkit-scrollbar-track {
    border-radius: 0px;
    background: rgba(0,0,0,0.1);
  }
::-webkit-scrollbar-thumb{
    border-radius: 0px;
    background: rgba(0,0,0,0.2);
  }
::-webkit-scrollbar-thumb:hover{
  background: rgba(0,0,0,0.4);
  }
::-webkit-scrollbar-thumb:active{
  background: rgba(0,0,0,.6);
  }
</style>
